import { useNavigate } from "react-router-dom";

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className="flex-1 px-4 py-4">
      <div className="flex items-center gap-2 mb-4">
        <button onClick={() => navigate(-1)}
          className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center cursor-pointer shrink-0">
          <i className="ri-arrow-left-s-line text-foreground-600 text-sm" />
        </button>
        <h1 className="text-base font-bold text-foreground-950">隐私政策</h1>
      </div>

      <div className="bg-white rounded-xl p-4 border border-background-200/60 space-y-5 text-xs text-foreground-600 leading-relaxed">
        <p>天鼎AI 重视您的隐私安全。本隐私政策旨在向您说明我们如何收集、使用、存储和保护您的个人信息。使用本平台服务即表示您已了解并同意本隐私政策的全部内容。</p>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第一条 信息收集</h2>

          <h3 className="text-xs font-semibold text-foreground-950 mb-1">1.1 您主动提供的信息</h3>
          <div className="space-y-1.5 mb-2">
            <p>（1）注册信息：手机号码用于账号识别和短信验证。这是我们识别您身份、提供登录服务所必需的信息。</p>
            <p>（2）个人资料：您可以选择填写显示名称、邮箱地址等信息，用于优化您的个人展示。</p>
            <p>（3）对话记录：您与 AI 交易员的对话内容，用于生成个性化回复和改进 AI 模型。</p>
            <p>（4）策略配置：您创建或使用的投资策略参数、自选股列表等，用于提供策略管理服务。</p>
          </div>

          <h3 className="text-xs font-semibold text-foreground-950 mb-1">1.2 自动收集的信息</h3>
          <div className="space-y-1.5">
            <p>（1）设备信息：操作系统版本、浏览器类型、IP 地址等基础设备信息，用于保障服务安全和兼容性。</p>
            <p>（2）使用数据：页面访问记录、功能使用频率、AI 调用次数等，用于优化产品体验和统计分析。</p>
            <p>（3）性能数据：页面加载时间、API 响应时间等，用于排查技术问题。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第二条 信息使用</h2>
          <div className="space-y-1.5">
            <p>2.1 我们收集的信息用于以下目的：</p>
            <p>（1）提供、维护和改进本平台服务。</p>
            <p>（2）通过短信发送账号安全通知（如登录提醒、重要变更通知）。</p>
            <p>（3）基于用户已明确表达的授权，发送 AI 交易决策短信提醒（此功能默认关闭，需用户主动开启）。</p>
            <p>（4）匿名化统计分析，用于产品优化和行业研究。</p>
            <p>（5）保障账号安全，识别和防范欺诈行为。</p>
            <p>2.2 我们不会将您的个人信息用于本政策未明确说明的其他目的。如需用于新的目的，我们将重新征求您的同意。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第三条 信息保护</h2>
          <div className="space-y-1.5">
            <p>3.1 传输安全：所有数据传输均采用 SSL/TLS 加密协议，确保数据在传输过程中不被窃听或篡改。</p>
            <p>3.2 存储安全：用户密码经 bcrypt 哈希加密存储，任何人（包括平台）均无法获取用户密码原文。</p>
            <p>3.3 数据隔离：不同用户的数据通过严格的访问控制策略隔离，防止未授权访问。</p>
            <p>3.4 安全审计：我们定期进行安全审计和代码审查，及时发现和修复安全漏洞。</p>
            <p>3.5 应急响应：如发生数据安全事件，我们将在 72 小时内向受影响用户发送通知。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第四条 信息共享与披露</h2>
          <div className="space-y-1.5">
            <p>4.1 未经您明确同意，我们不会向任何第三方出售或共享您的个人信息。</p>
            <p>4.2 以下情况除外：</p>
            <p>（1）法律法规要求披露的（如公安机关、司法机关依法查询）。</p>
            <p>（2）为维护国家安全、公共安全或重大公共利益所必需。</p>
            <p>（3）为维护您或其他个人的生命、财产安全所必需。</p>
            <p>4.3 我们可能会与为我们提供服务的技术合作伙伴（如云服务商、短信服务商）共享必要的信息，但这些合作伙伴受到严格的保密协议约束，不得将您的信息用于任何其他目的。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第五条 信息保留与删除</h2>
          <div className="space-y-1.5">
            <p>5.1 在您的账号存续期间，我们保留您的相关数据。</p>
            <p>5.2 您注销账号后，我们将在合理期限内（通常为 30 天）删除或匿名化处理您的个人数据。</p>
            <p>5.3 根据法律法规要求必须保留的数据（如交易记录），我们将在法定保留期满后删除。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第六条 您对数据的权利</h2>
          <div className="space-y-1.5">
            <p>6.1 查阅权：您有权随时查看您的个人信息和使用数据。</p>
            <p>6.2 更正权：如您的个人信息发生变化或不准确，您有权更正。</p>
            <p>6.3 删除权：您有权要求删除您的账号及相关数据。</p>
            <p>6.4 撤回同意权：对于基于"同意"处理的数据（如短信通知），您可以随时撤回同意。</p>
            <p>6.5 数据可携带权：您有权要求我们将您的数据以结构化、通用的格式提供给您。</p>
            <p>如您需要行使上述权利，可通过本平台内的"账户设置"进行操作，或联系我们的客服。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第七条 Cookie 与追踪技术</h2>
          <div className="space-y-1.5">
            <p>7.1 我们使用必要的 Cookie 来维持您的登录状态和会话信息。</p>
            <p>7.2 我们不使用第三方追踪 Cookie 用于广告投放。</p>
            <p>7.3 您可以通过浏览器设置禁用 Cookie，但这可能影响部分功能的正常使用。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第八条 政策更新</h2>
          <div className="space-y-1.5">
            <p>8.1 我们可能会不定期更新本隐私政策，以反映服务变化、法律法规更新或行业最佳实践。</p>
            <p>8.2 重大变更时，我们将通过平台公告、短信或弹窗等方式通知您。</p>
            <p>8.3 更新后的政策自公布之日起生效。如您不同意变更，请停止使用本平台服务并删除账号。</p>
          </div>
        </section>

        <p className="text-[10px] text-foreground-400 pt-2 border-t border-background-100">版本：V1.0 &#8226; 最后更新：2026年7月</p>
      </div>
    </div>
  );
}
